import React from "react";

function TermsAndConditions() {
  return (
    <div className="terms-and-conditions container">
      <h1>Terms and Conditions</h1>
      <p class="last-updated">Last updated: Feb 15, 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to Geekun! These Terms and Conditions govern your use of our
          app, Geekun. By accessing or using the app, you agree to comply with
          and be bound by these Terms. If you do not agree to these Terms,
          please do not use the app.
        </p>
      </section>

      <section>
        <h2>2. Use of the App</h2>
        <p>
          Geekun provides a platform that allows users to identify anime and
          manga series from images. The app offers information about various
          anime and manga series based on images provided by the user. You are
          responsible for how you use the app and its content.
        </p>
      </section>

      <section>
        <h2>3. Intellectual Property</h2>
        <p>
          Geekun does not own any of the anime or manga content displayed in the
          app. All anime and manga images, names, and related information belong
          to their respective owners. The app serves only as an informational
          tool, and we do not claim any ownership over the content. If you
          believe any content violates intellectual property rights, please
          contact us.
        </p>
      </section>

      <section>
        <h2>4. User Obligations</h2>
        <p>As a user of Geekun, you agree to:</p>
        <ul>
          <li>
            Use the app in compliance with applicable laws and regulations.
          </li>
          <li> Respect the rights of anime/manga creators.</li>
          <li>Not use the app for any unlawful or unauthorized purposes.</li>
        </ul>
      </section>

      <section>
        <h2>5. Limitation of Liability</h2>
        <p>
          Geekun is provided "as is" without warranties of any kind, either
          express or implied. We do not guarantee the accuracy, completeness, or
          usefulness of the app. In no event shall Geekun be liable for any
          damages arising from the use or inability to use the app, including
          but not limited to direct, indirect, incidental, or consequential
          damages.
        </p>
      </section>

      <section>
        <h2>6. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of Morocco, without regard to its conflict of law principles.
        </p>
      </section>

      <section>
        <h2>7. Changes to Terms</h2>
        <p>
          We may update these Terms and Conditions from time to time. Any
          changes will be posted on this page, and we will notify you of any
          significant changes. Your continued use of the app after any
          modifications signifies your acceptance of the updated Terms.
        </p>
      </section>

      <section>
        <h2>8. Termination</h2>
        <p>
          We reserve the right to terminate or suspend your access to Geekun at
          our sole discretion, without notice, for any reason, including but not
          limited to violation of these Terms.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about these Terms and Conditions, please
          contact us at:
        </p>
        <p>Email: geekun.business@gmail.com</p>
      </section>
    </div>
  );
}

export default TermsAndConditions;
